var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"avatar"},[_c('img',{staticClass:"avatar__image",attrs:{"src":_vm.setAvatar,"title":_vm.title,"alt":_vm.$t('avatarComponents.alt').toString(),"decode":"async"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }